/*
  NSC 8-point review stars (AXEL, 2026-10-18). Staged on an unpublished theme only.
  Klaviyo Reviews draws each star as an inline <svg> with a 5-point <path> filled by a
  gradient (that gradient carries the partial fill, e.g. 4.88 stars). This swaps only the
  path geometry for the NSC 8-point star, so Klaviyo's own full / partial / empty logic
  keeps working. Colour lives in nsc-review-stars.css. Shape master:
  Loft-nsc/brands/nsc/assets/review-star/nsc-review-star-8pt.svg
*/
(function () {
  var D = 'M10 0.5 L11.818 5.612 L16.718 3.282 L14.388 8.182 L19.5 10 L14.388 11.818 L16.718 16.718 L11.818 14.388 L10 19.5 L8.182 14.388 L3.282 16.718 L5.612 11.818 L0.5 10 L5.612 8.182 L3.282 3.282 L8.182 5.612 Z';
  var SEL = 'svg.kl_reviews__full_star > path, svg.kl_reviews__partial_star > path, svg.kl_reviews__empty_star > path';
  // Distribution graph star: Klaviyo draws it as a bare 9x10 <svg> with no viewBox. Give it the
  // same 20-unit box as the rating stars so the same path fills it; size + colour are in the CSS.
  var HSEL = '.kl_reviews__histogram__row > svg';
  function swap(p) {
    if (p.getAttribute('d') !== D) { p.setAttribute('d', D); p.setAttribute('stroke', 'none'); }
  }
  function swapH(svg) {
    if (svg.getAttribute('viewBox') !== '0 0 20 20') svg.setAttribute('viewBox', '0 0 20 20');
    var p = svg.querySelector('path');
    if (p) { p.removeAttribute('clip-rule'); swap(p); }
  }
  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches(SEL)) swap(root);
    if (root.matches(HSEL)) swapH(root);
    var list = root.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) swap(list[i]);
    var hist = root.querySelectorAll(HSEL);
    for (var k = 0; k < hist.length; k++) swapH(hist[k]);
  }
  scan(document.documentElement);
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.type === 'attributes') {
        var t = r.target;
        if (t.matches && t.matches(SEL)) swap(t);
        else if (t.parentNode && t.parentNode.matches && t.parentNode.matches(HSEL)) swapH(t.parentNode);
        continue;
      }
      for (var j = 0; j < r.addedNodes.length; j++) scan(r.addedNodes[j]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['d'] });
})();
